import React from 'react';
import { Select, Space } from 'antd';
import { RobotOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { App as AntdApp } from 'antd';
import { useModelStore } from '../stores/model';

/** Model options keys -> translation path under `model.models` */
const MODEL_OPTIONS = [
  { value: 'gpt4o', tKey: 'gpt4o' },
  { value: 'claude35Sonnet', tKey: 'claude35Sonnet' },
  { value: 'tongyi', tKey: 'tongyi' },
  { value: 'deepseek', tKey: 'deepseek' },
  { value: 'fastgpt', tKey: 'fastgpt' },
];

/**
 * ModelSelector - Ant Design Select for switching between available AI models.
 * Reads/writes the current model from the global Zustand useModelStore.
 */
export default function ModelSelector() {
  const { t } = useTranslation();
  const { message } = AntdApp.useApp();
  const currentModel = useModelStore((s) => s.currentModel);
  const setModel = useModelStore((s) => s.setModel);

  const options = MODEL_OPTIONS.map((opt) => ({
    value: opt.value,
    label: (
      <Space>
        <RobotOutlined />
        {t(`model.models.${opt.tKey}`)}
      </Space>
    ),
  }));

  const handleChange = (value) => {
    setModel(value);
    const tKey = MODEL_OPTIONS.find((o) => o.value === value)?.tKey ?? value;
    const label = t(`model.models.${tKey}`);
    message.success(t('model.switchSuccess', { name: label }));
  };

  return (
    <Select
      value={currentModel}
      onChange={handleChange}
      options={options}
      style={{ minWidth: 160 }}
      suffixIcon={<RobotOutlined />}
      popupMatchSelectWidth={false}
      aria-label={t('model.label')}
    />
  );
}
